var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoopItemPanel',{attrs:{"title":"Slide"}},[_c('div',{staticClass:"canvas-blocks-solar-sliderBravo-LoopItemPanel"})])}
var staticRenderFns = []

export { render, staticRenderFns }